<template>
  <v-container class="findings-form-level-one-container" :class="[getFindingOneClass()]">
    <v-layout row wrap>
      <v-flex xs4>
        <v-select
          v-if="finding.questions.finding"
          hide-details
          :items="findingOptionItems"
          :value="finding.questions.finding.value"
          :class="['pt-0', getFocusClass('finding')]"
          label="Finding"
          @change="$emit('change', { field: 'finding', newValue: $event })"></v-select>
      </v-flex>
      <v-flex xs2 class="pl-4"
        v-if="isNumberInputShow">
        <div :class="['input-container', getFocusClass('number')]">
          <div class="input-header">Number</div>
          <v-text-field
            type="text"
            min="0"
            :value="finding.questions.number.value || 1"
            hide-details
            @change="$emit('change', { field: 'number', newValue: $event })"></v-text-field>
        </div>
      </v-flex>
      <v-flex xs5 class="pl-4"
        v-if="isTakeNoteOfInputShow">
        <div
          :class="['input-container', getFocusClass('takeNote')]"
          v-if="finding.questions.takeNote">
          <div class="input-header">Take Note Of</div>
          <v-select
            hide-details
            :items="takeNoteOptionItems"
            :value="finding.questions.takeNote.value"
            @change="$emit('change', { field: 'takeNote', newValue: $event })"></v-select>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import forms from '@/utils/forms'

  export default {
    name: 'ExaminationFindingsFormLevelOne',

    props: {
      findingIndex: Number,
      finding: Object,
      questions: Object,
      hiddenParams: {
        required: false,
        type: Object
      },
      isExamination: Boolean
    },

    data() {
      return {}
    },

    computed: {
      findingQID() {
        return this.finding.questions.finding.questionID
      },

      takeNoteQID() {
        return this.finding.questions.takeNote.questionID
      },

      isCountableFinding() {
        return this.finding.questions.finding && this.finding.questions.number
      },

      isNumberInputShow() {
        return this.isCountableFinding && this.finding.questions.number
      },

      isTakeNoteOfInputShow() {
        return this.isCountableFinding
          && this.finding.questions
          && this.finding.questions.number
          && (Number(this.finding.questions.number.value) > 1)
          && this.questions[this.findingQID].options
      },

      findingOptionItems() {
        const qID = this.findingQID
        const options = this.questions[qID].options

        let temp_options = [];
        let temp_obj = {};
        for (let key in options) {
          temp_options.push(options[key]);
          temp_obj[options[key]] = {
            value: key,
            text: options[key].charAt(0).toUpperCase() + options[key].slice(1)
          };
        }
        temp_options.sort();

        let arr = [];
        for (let i in temp_options) {
          arr.push(temp_obj[temp_options[i]]);
        }

        return arr
      },

      takeNoteOptionItems() {
        const qID = this.takeNoteQID
        const options = this.questions[qID].options

        let arr = []

        for (const key in options) {
          arr.push({
            value: key,
            text: options[key]
          })
        }

        return arr
      }
    },
    methods: {
      getFocusClass(key) {
        if (this.hiddenParams) {
          return this.hiddenParams.focus == key ? 'focus' : ''
        } else {
          return ''
        }
      },
      getFindingOneClass() {
        if (this.isExamination) return 'is-examination';
      },

    }
  }

</script>
